export default __webpack_public_path__ + "static/media/mercado-600x600.998214c4.jpg";